<!--
 * @Descripttion:
 * @version:

 * @Author: shenlin
 * @Date: 2021-10-28 10:31:17
 * @LastEditors: mobai
 * @LastEditTime: 2022-12-07 14:59:34
-->
<template>
  <div class="container">
    <section
      class="topContent"
      :style="{ height: !isEditEnt ? '100%' : 'calc(100% - 56px)' }"
    >
      <div v-if="!isReceive || !isEditEnt" class="topTips">
        <el-alert
          :title="
            !isEditEnt
              ? '当前服务券截止时间已到，请补发或新建服务券'
              : '已有企业申领该批次的服务券，部分功能将无法编辑'
          "
          type="warning"
          show-icon
          :closable="false"
        >
        </el-alert>
      </div>
      <section class="header">
        <div class="title">{{ !id ? '新建' : '编辑' }}服务券批次</div>
        <div class="information">
          <el-form
            :model="baseForm"
            :rules="baseRules"
            ref="baseForm"
            class="demo-ruleForm"
          >
            <el-form-item label="批次名称：" prop="couponName">
              <el-input
                placeholder="请输入"
                class="inputStyle"
                v-model="baseForm.couponName"
                :disabled="!isReceive || grantNumMax > 1"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="批次总金额："
              prop="grossAmount"
              class="specialRow"
            >
              <el-input
                placeholder="请输入数字"
                v-model="baseForm.grossAmount"
                class="inputStyle"
                @input="clearServiceAmount()"
                :disabled="!isReceive || grantNumMax > 1"
              ></el-input
              ><span class="withUnitInput">元</span>
            </el-form-item>

            <div class="surplus-box" v-if="grantNumMax > 1">
              <span
                ><el-tooltip
                  class="item"
                  effect="dark"
                  content="剩余金额=每期未发放金额+未领取金额+未使用金额"
                  placement="top"
                  ><i
                    class="el-icon-warning-outline tips-icon"
                  ></i> </el-tooltip
                ><span class="left-text">剩余金额：</span
                >{{ handleAmount(baseForm.surplusAmount) }}</span
              ><span class="unit">元</span>
            </div>

            <el-tabs
              v-model="editableTabsValue"
              type="card"
              @tab-click="handleClick"
            >
              <el-tab-pane
                :label="`第${index + 1}次发放`"
                :name="item + ''"
                v-for="(item, index) in grantNumMax"
                :key="index"
              ></el-tab-pane>
              <el-tab-pane label="+" name="add"></el-tab-pane>
            </el-tabs>

            <el-form-item
              label="本期发放金额："
              prop="totalMoney"
              class="specialRow"
            >
              <el-input
                placeholder="请输入数字"
                v-model="baseForm.totalMoney"
                class="inputStyle"
                @input="clearServiceAmount()"
                :disabled="!isReceive"
              ></el-input
              ><span class="withUnitInput">元</span>
              <!-- <div class="totalMoneyTips">
                {{
                  id && editableTabsValue != '1'
                    ? '后续补发的服务券总金额根据当前服务券批次剩余金额自动计算，且无法修改'
                    : '即设置此次服务券批次的总金额，无需设置单张服务券的面值和数量，发放超过单类型上限或超过总金额将会自动停止发放'
                }}
              </div> -->
            </el-form-item>
            <el-form-item label="发放与使用时间：" prop="useTime">
              <el-date-picker
                v-model="baseForm.useTime"
                type="datetimerange"
                @change="changeTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                class="inputStyle"
                clearable
                :disabled="!isReceive"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="服务券类型：" prop="serviceType">
              <el-checkbox-group
                v-model="selectServiceType"
                :disabled="!isReceive"
                @change="serviceTypeSelect"
              >
                <el-checkbox
                  :label="item.name"
                  :value="item.name"
                  v-for="(item, index) in typeList"
                  :disabled="item.disabled"
                  :key="index"
                  >{{ item.name
                  }}<span class="typeTips" v-if="item.name === '通用'"
                    >（通用券可用于购买所有类型的商品，但不可与其他类型的服务券同时发放）</span
                  ></el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </div>
        <div class="serviceSetBox">
          <div class="table-box">
            <el-table
              ref="multipleTable"
              :data="baseForm.serviceType"
              tooltip-effect="dark"
              style="width: 100%"
              border
            >
              <el-table-column
                prop="serviceType"
                label="服务券类型"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="address"
                label="类型发放上限设置"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="editBox">
                    <div>
                      百分比（%）：
                      <el-input
                        v-model="scope.row.grantRate"
                        autocomplete="off"
                        placeholder="请输入"
                        type="number"
                        class="tableInputStyle count"
                        :disabled="!isReceive"
                        @input="
                          setPercentage(scope.$index, scope.row.grantRate)
                        "
                      ></el-input>
                    </div>
                    <div>
                      <!-- (scope.row.grantRate * baseForm.totalMoney) / 100 || '-' -->
                      金额小计（元）：<el-input
                        type="number"
                        v-model="scope.row.totalMoney"
                        autocomplete="off"
                        placeholder="请输入"
                        class="tableInputStyle count"
                        :disabled="!isReceive"
                        @input="
                          setServiceAmount(scope.$index, scope.row.totalMoney)
                        "
                      ></el-input>
                      <div
                        class="redTips"
                        v-if="
                          Number(scope.row.totalMoney) >
                          Number(baseForm.totalMoney)
                        "
                      >
                        上限不可大于总金额
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="total-Statistics">
              <span class="entDataTip" v-if="isExceed()"
                ><i class="el-icon-warning-outline tips-icon"></i
                >合计已大于本期总金额，但仍可发放</span
              >
              <span class="total-text">总计：</span
              ><span class="highlight" v-if="baseForm.serviceType.length">{{
                totalCumulative
              }}</span
              >元
            </div>
          </div>
        </div>
      </section>
      <section class="header">
        <div class="information">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            class="demo-ruleForm"
          >
            <el-form-item label="单张券面值：" prop="couponAmount">
              <el-input
                type="number"
                placeholder="请输入"
                class="inputStyle"
                v-model="ruleForm.couponAmount"
                :disabled="!isReceive"
              ></el-input
              ><span class="withUnitInput">元</span>
            </el-form-item>
            <el-form-item label="服务券抵扣：" prop="consumeRate">
              <el-input
                placeholder="请输入"
                class="inputStyle"
                v-model="ruleForm.consumeRate"
                :disabled="!isReceive"
              ></el-input
              ><span class="withUnitInput">%</span>
            </el-form-item>
            <el-form-item label="白名单确认" class="bottomEntWhite">
              <el-input
                v-model="ruleForm.settingEntItem"
                placeholder=""
                style="opacity: 0"
              ></el-input>
            </el-form-item>
            <span class="tips entDataTip">
              <i class="el-icon-warning-outline tips-icon"></i
              >注：只展示今年最新白名单
              <!-- 编辑且不是第一次补发 -->
              <span v-if="id && editableTabsValue != '1'"
                >，且当前批次下之前未领取服务券的企业</span
              >
            </span>
            <div class="list-box-header">
              <div class="header-left">
                <el-input
                  class="inputStyle"
                  v-model="key"
                  placeholder="搜索企业名称"
                  @keyup.enter.native="getEntWhiteSetting"
                  clearable
                  @clear="getEntWhiteSetting"
                >
                  <i
                    @click="getEntWhiteSetting"
                    slot="suffix"
                    class="el-input__icon el-icon-search"
                  ></i
                ></el-input>

                <el-select
                  v-model="areaName"
                  placeholder="请选择区域"
                  @change="getEntWhiteSetting"
                  clearable
                  class="select-box"
                >
                  <el-option
                    v-for="item in areaList"
                    :key="item.county"
                    :label="item.county"
                    :value="item.county"
                  >
                  </el-option>
                </el-select>

                <el-input
                  class="amountRange"
                  v-model="minAmount"
                  placeholder="最低金额"
                  @keyup.enter.native="getEntWhiteSetting"
                  clearable
                  @clear="getEntWhiteSetting"
                >
                </el-input>
                ~
                <el-input
                  class="amountRange"
                  v-model="maxAmount"
                  placeholder="最高金额"
                  @keyup.enter.native="getEntWhiteSetting"
                  clearable
                  @clear="getEntWhiteSetting"
                >
                </el-input>
                <el-button @click="resetData">重置</el-button>
                <el-button class="highlight-btn" @click="getEntWhiteSetting"
                  >查询</el-button
                >
              </div>
              <div class="list-box-header-tag" @click="allSetting()">
                <el-tooltip
                  placement="top"
                  content="为当前选中的企业批量设置单次服务券领取上限"
                >
                  <el-tag effect="plain" type="info">
                    批量设置 <i class="el-icon-warning-outline"></i>
                  </el-tag>
                </el-tooltip>
              </div>
            </div>
            <div class="table-box">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange"
                border
              >
                <el-table-column
                  type="selection"
                  width="80"
                  align="center"
                  :selectable="selectInit"
                >
                </el-table-column>
                <el-table-column
                  prop="areaName"
                  label="所属区域"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="entName" label="企业名称" align="center">
                </el-table-column>
                <el-table-column
                  prop="address"
                  label="单次服务券领取上限（元）"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <div>
                      <el-input
                        v-model="scope.row.singleServiceCoupon"
                        autocomplete="off"
                        placeholder="请输入"
                        class="tableInputStyle"
                        :disabled="
                          (id && !isAddReissue && !scope.row.isReceive) ||
                          !isEditEnt
                        "
                        @blur="tipsText = null"
                        @input="
                          onExchange(
                            scope.$index,
                            scope.row.singleServiceCoupon
                          )
                        "
                      ></el-input>
                      <div
                        class="redTips"
                        v-if="scope.$index == currentIndex && tipsText"
                      >
                        {{ tipsText }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="table-page">
                <el-pagination
                  background
                  layout="total,prev, pager, next, sizes, jumper"
                  :current-page.sync="pageNum"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-size="pageSize"
                  :total="totalRecord"
                >
                </el-pagination>
              </div>
            </div>
          </el-form>
        </div>
      </section>
    </section>
    <section class="footer" v-if="isEditEnt">
      <div class="footer-content">
        <el-button @click="handleClose()">取消</el-button>
        <el-button
          type="primary"
          @click="distributeCoupon(editStatus)"
          v-if="id && !reissueNewAdd"
          >保存</el-button
        >
        <el-button
          v-if="!id || reissueNewAdd"
          type="primary"
          @click="distributeCoupon(0)"
          >仅保存</el-button
        >
        <el-button
          v-if="!id || reissueNewAdd"
          type="primary"
          @click="distributeCoupon(1)"
          >保存并上架</el-button
        >
      </div>
    </section>
    <el-dialog
      title="批量设置"
      :visible.sync="dialogFormVisible"
      class="dialogBox"
    >
      <div class="tips">为勾选的所有企业批量设置服务券面值</div>
      <el-form :model="dialogForm" :rules="dialogRule" ref="dialogForm">
        <el-form-item label="服务券面值" prop="uniteAmount">
          <el-input
            v-model="dialogForm.uniteAmount"
            autocomplete="off"
            placeholder="请输入数字"
            class="inputStyle"
          ></el-input
          ><span class="unit">元</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchSettings()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="tipsVisible"
      width="25%"
      top="15%"
      class="tipDialog"
    >
      <div slot="title">
        <i class="el-icon-info"></i
        ><span class="title">{{
          errorReason ? '服务券补发创建失败' : '是否补发服务券'
        }}</span>
      </div>
      <div class="reasonBox" v-if="errorReason">{{ errorReason }}</div>
      <div class="reasonBox" v-else>当前能够进行服务券补发，是否补发？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelReissue()" v-if="!errorReason"
          >取 消</el-button
        >
        <el-button type="primary" @click="addCoupons()" v-if="!errorReason"
          >确 定</el-button
        >
        <el-button type="primary" @click="cancelReissue()" v-if="errorReason"
          >知道了</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  entWhite,
  checkCouponName,
  distributeCoupon,
  couponDetail,
  couponDetailByPage,
  judgeReissue,
  serviceTypeDictList
} from '@api/yardVoucher/serviceVoucherBatchManagement/index'
import { getArea } from '@api/common'
import { formatAmount } from '@utils'
import { isPosInteger, isOneToHundredInteger } from '../../../utils/validate'
import { number } from 'echarts'
export default {
  name: 'Live',
  data() {
    var validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写服务券批次名称'))
      } else {
        callback()
      }
    }
    var validateGrossAmount = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        callback(new Error('请输入批次总金额'))
      } else if (!isPosInteger(value)) {
        callback(new Error('只允许输入大于0的整数'))
      } else {
        callback()
      }
    }
    var validateTotal = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入本期发放金额'))
      } else if (!isPosInteger(value)) {
        callback(new Error('只能输入正整数'))
      } else if (this.grantNumMax == 1 && Number(value) > Number(this.baseForm.grossAmount)) {
        callback(new Error('本期发放金额不能大于批次总金额'))
      } else if (this.grantNumMax > 1 && Number(value) > Number(this.baseForm.surplusAmount)) {
        callback(new Error('本期发放金额不能大于剩余金额'))
      } else {
        callback()
      }
    }
    var validateGrantRate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('单类型的服务券发放金额不能为空'))
      } else if (!isOneToHundredInteger(value)) {
        callback(new Error('只能输入1-100的整数数字'))
      } else {
        callback()
      }
    }
    var validateConsumeRate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('使用服务券能抵消的金额占服务券值比不能为空'))
      } else if (!isOneToHundredInteger(value)) {
        callback(new Error('只能输入1-100的整数数字'))
      } else {
        callback()
      }
    }

    var validateUniteAmount = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入服务券面值'))
      } else {
        callback()
      }
    }

    var validateTime = (rule, value, callback) => {
      const isOverdue = new Date(value[1]).getTime() < new Date().getTime()
      if (value === '') {
        callback(new Error('请选择服务券发放与使用时间'))
      } else if (isOverdue) {
        callback(new Error('服务券选择使用截止时间需在当前时间之后'))
      } else {
        callback()
      }
    }
    return {
      title: '',
      dialogVisible: false,
      baseForm: {
        couponName: '',
        serviceType: [],
        couponStartTime: '',
        couponEndTime: '',
        useTime: '',
        grossAmount: '',
        surplusAmount: '',
        totalMoney: '' // 总金额
      },
      ruleForm: {
        consumeRate: '', // 每次使用服务券能抵消的金额占服务券面值的比率
        settingEntItem: 'add',
        couponAmount: '10000' // 单张券面值，默认10000
      },
      key: '', // 企业名称搜索
      minAmount: '', // 最低金额
      maxAmount: '', // 最高金额
      baseRules: {
        totalMoney: [
          { required: true, validator: validateTotal, trigger: 'blur' }
        ],
        couponName: [
          { required: true, validator: validateName, trigger: 'blur' }
        ],
        grossAmount: [
          { required: true, validator: validateGrossAmount, trigger: 'blur' }
        ],
        useTime: [
          {
            type: 'date',
            required: true,
            validator: validateTime,
            // message: '发放与使用时间',
            trigger: 'blur'
          }
        ],
        serviceType: [
          { required: true, message: '请选择服务券类型', trigger: 'change' }
        ]
      },
      rules: {
        consumeRate: [
          {
            required: true,
            validator: validateConsumeRate,
            trigger: 'blur'
          }
        ],
        couponAmount: [
          {
            required: true,
            message: '请输入单张券面值',
            trigger: 'blur'
          }
        ],
        settingEntItem: [
          {
            required: true,
            message: '白名单确认',
            trigger: 'blur'
          }
        ]
      },
      status: '',
      selectServiceType: [],
      serviceTableData: [],
      serviceTypeList: [],
      typeList: [],
      tableData: [],
      dialogFormVisible: false,
      dialogForm: {
        uniteAmount: ''
      },
      dialogRule: {
        uniteAmount: [
          {
            required: true,
            // message: '请输入服务券面值',
            validator: validateUniteAmount,
            trigger: 'blur'
          }
        ]
      },
      pageNum: 1,
      pageSize: 10,
      totalRecord: 0,
      entServiceCouponList: [],
      allSelectEntData: [], // 所有修改项值，由于翻页引起会有空值的情况
      selectCouponList: [], // 批量设置，选中的列表项信息
      id: '', // 编辑 id
      editStatus: '', // 编辑状态
      isReceive: true, // 是否已有企业申领该批次的服务券，部分功能将无法编辑
      currentIndex: null,
      tipsText: null,
      editableTabsValue: '1',
      grantNumMax: 1,
      tipsVisible: false,
      errorReason: '', // 补发券不可创建原因

      firstCouponId: '', // 补发时传递第一次id
      isAddReissue: false, // 新增补发标识
      reissueInfo: {}, // 最新补发信息，还未提交
      reissueNewAdd: false, // 补发新建标识
      lastTimeCoupons: {}, // 上一次保留信息
      currentSelectIndex: null,
      isEditEnt: true,
      totalCumulative: '', // 服务券类型发放上线总额累计
      amountServiceItem: false,
      areaName: '', // 区域
      areaList: []
    }
  },
  watch: {
    baseForm: {
      handler: function (val) {
        this.saveData('baseForm')
      },
      deep: true
    },
    'baseForm.serviceType': {
      handler(val) {
        this.getTotalCumulative()
      },
      deep: true
    },
    ruleForm: {
      handler: function (val) {
        this.saveData('ruleForm')
      },
      deep: true
    }
  },
  created() { },
  async mounted() {
    this.id = this.$route.query.id
    this.editStatus = this.$route.query.status
    await this.geServiceTypeList()
    this.getArea()
    // 如果是编辑，则默认选中最后一次补发券
    if (this.$route.query.grantNumMax) {
      this.editableTabsValue = this.$route.query.grantNumMax + ''
      this.handleClick()
    } else {
      this.getEntWhiteSetting()
    }
  },
  methods: {
    handleAmount(val) {
      return val ? formatAmount(val) : '0'
    },
    /** 获取丽水市以及各个区县 */
    getArea() {
      getArea({}).then(res => {
        if (res.data.code == '0000') {
          this.areaList = res.data.data || []
        }
      })
    },
    // 获取服务券类型字典
    geServiceTypeList() {
      return new Promise((resolve) => {
        serviceTypeDictList().then((res) => {
          if (res.data.code == '0000') {
            res.data.data.map((item) => {
              item.disabled = false
            })
            this.typeList = res.data.data
            this.typeList.reverse()
            resolve()
          }
        })
      })
    },
    // 填写的服务券类型上限是否超过总金额
    isExceed() {
      return this.baseForm.totalMoney < this.totalCumulative
    },
    // 保存 分发券信息，保证来回切换返显
    saveData(dataType) {
      if (this.isAddReissue && this.editableTabsValue == this.grantNumMax) {
        let data = JSON.parse(JSON.stringify(this[dataType]))
        this.reissueInfo = { ...this.reissueInfo, ...data }
      }
    },
    // 取消发放、发放失败
    cancelReissue() {
      this.tipsVisible = false
      this.editableTabsValue = this.currentSelectIndex || 1 + ''
    },
    // 确定分发券
    addCoupons() {
      this.tipsVisible = false
      this.grantNumMax = ++this.grantNumMax
      // debugger
      this.editableTabsValue = this.grantNumMax + ''

      // 清空当前页面数据
      this.baseForm.couponStartTime = ''
      this.baseForm.couponEndTime = ''
      this.baseForm.serviceType = []
      this.baseForm.totalMoney = this.lastTimeCoupons.surplusAmount
      this.baseForm.couponName = this.lastTimeCoupons.couponName
      this.baseForm.grossAmount = this.lastTimeCoupons.grossAmount
      this.baseForm.surplusAmount = this.lastTimeCoupons.surplusAmount

      this.baseForm.useTime = ''
      this.ruleForm.consumeRate = ''
      this.entServiceCouponList = []
      this.selectServiceType = []
      this.serviceTypeList = []
      this.isReceive = true

      // 新增补发标识
      this.isAddReissue = true
      this.isEditEnt = true
      this.reissueNewAdd = true
      // this.currentSelectIndex = this.editableTabsValue // 记住当前选择的补发项
      this.getWhiteEntList()
      // 全部放开选择服务券类型
      this.selectTypeFn(this.selectServiceType)
    },
    // 新增发放券前判断是否能创建服务券补发,传递第一次发放id
    judgeReissue() {
      judgeReissue({
        id: this.firstCouponId,
        grantNum:
          this.editableTabsValue == 'add' ? this.grantNumMax + 1 : this.grantNum
      }).then((res) => {
        if (res.data.code === '0000') {
          this.tipsVisible = true
          this.lastTimeCoupons = res.data.data // 新建发放，总金额展示上一次的剩余金额// 页面新建成功后保存上一次信息
        } else {
          this.tipsVisible = true
          this.errorReason = res.data.msg
        }
      })
    },
    // 添加发放
    async handleClick(data) {
      if (data && data.name == 'add') {
        // 点击新增补发券
        this.judgeReissue()
      } else if (
        this.isAddReissue &&
        data &&
        data.index == this.grantNumMax - 1
      ) {
        // 当前点击为新增的补发券，还未提交
        this.currentSelectIndex = this.editableTabsValue // 为什么要记住选择，因为这里有可能新建补发页面失败，需要选中上一次选择的是第几次的补发返显
        this.reissueNewAdd = true
        this.selectServiceType = []
        let {
          useTime,
          couponEndTime,
          couponStartTime,
          serviceType,
          consumeRate,
          couponAmount
        } = this.reissueInfo
        this.baseForm = {
          totalMoney: this.lastTimeCoupons.surplusAmount, // 最新一次补发，返显剩余金额
          couponName: this.lastTimeCoupons.couponName,
          grossAmount: this.lastTimeCoupons.grossAmount,
          surplusAmount: this.lastTimeCoupons.surplusAmount,
          useTime,
          couponEndTime,
          couponStartTime,
          serviceType
        }
        this.serviceTypeList = serviceType
        serviceType &&
          serviceType.length &&
          serviceType.map((item) => {
            this.selectServiceType.push(item.serviceType)
          })

        this.ruleForm = { consumeRate, couponAmount }
        this.isReceive = true
        this.isEditEnt = true
        this.getWhiteEntList()
        this.selectTypeFn(this.selectServiceType)
      } else {
        this.currentSelectIndex = this.editableTabsValue
        this.reissueNewAdd = false
        // 切换之前的补发券
        await this.getBasicInfo()
        await this.getEditWhiteEnt()
      }
    },
    // 给当前服务券类型设置发放上线  0 到 100 的数
    setPercentage(index, value) {
      if (!this.baseForm.totalMoney) {
        this.baseForm.serviceType[index].grantRate = ''
        this.$message.error('请先设置总金额')
        return
      }
      this.baseForm.serviceType[index].grantRate = value.replace(
        /^(-[0-9][0-9]*)$/gi,
        ''
      )
      this.baseForm.serviceType[index].grantRate = (value.match(
        /^[0-9]+(\.[0-9]{0,2})?/g
      ) ?? [''])[0]
      if (value > 100) {
        this.baseForm.serviceType[index].grantRate = 100
        value = 100
      }
      let currentValue = this.baseForm.serviceType[index].grantRate
      // 百分比改变,金额总计保留两位小数
      this.baseForm.serviceType[index].totalMoney = currentValue
        ? ((currentValue * this.baseForm.totalMoney) / 100).toFixed(2)
        : ''
      let data = this.baseForm.serviceType[index]
      this.$set(this.baseForm.serviceType, index, data)
    },
    // 给当前服务券类型设置发放金额 最多两位小数 联动百分比
    setServiceAmount(index, value) {
      if (!this.baseForm.totalMoney) {
        this.baseForm.serviceType[index].totalMoney = ''
        this.$message.error('请先设置总金额')
        return
      }
      this.amountServiceItem = value > this.baseForm.totalMoney // 单项超过总金额，展示提示语
      this.baseForm.serviceType[index].totalMoney = (value.match(
        /^[0-9]+(\.[0-9]{0,2})?/g
      ) ?? [''])[0]

      let currentRate = ''
      if (value) {
        let rateArr = ((value * 100) / this.baseForm.totalMoney)
          .toString()
          .split('.')
        currentRate =
          rateArr.length > 1
            ? rateArr[0] + '.' + rateArr[1].slice(0, 2)
            : rateArr[0]
      }
      this.baseForm.serviceType[index].grantRate = value
        ? Number(currentRate) // 保留两位小数，不四舍五入
        : ''
    },
    // 获取服务券类型的总额累计值
    getTotalCumulative() {
      this.totalCumulative = 0
      this.baseForm.serviceType.map((item) => {
        this.totalCumulative = this.totalCumulative + Number(item.totalMoney)
      })
    },
    // 通用和其他类型选其一
    selectTypeFn(value) {
      // 点击通用类型，其他类型禁用，反选通用，其他类型可勾选
      this.typeList.map((item, index) => {
        if (value.includes('通用')) {
          item.disabled = item.name != '通用'
        } else if (value.length && !value.includes('通用')) {
          // 选择非通用，则通用禁用
          item.disabled = item.name == '通用'
        } else {
          // 什么也没选，则全部放开可勾选
          item.disabled = false
        }
      })
    },
    // 服务券类型选择联动下面的表格
    serviceTypeSelect(value) {
      this.selectTypeFn(value)
      let new_arr = []
      value.map((item, index) => {
        // 返显之前操作项
        let itemData = null
        if (this.baseForm.serviceType.length) {
          itemData = this.baseForm.serviceType.filter(
            (d) => d.serviceType == item
          )[0]
        }
        new_arr.push({
          serviceType: item,
          totalMoney: itemData ? itemData.totalMoney : '',
          grantRate: itemData ? itemData.grantRate : ''
        })
      })
      // new_arr.map((d) => {
      //   this.serviceTypeList.forEach((item) => {
      //     if (d.serviceType == item.serviceType) {
      //       d.totalMoney = item.totalMoney
      //     }
      //   })
      // })
      this.baseForm.serviceType = new_arr
    },
    selectInit(scope) {
      if (!this.isEditEnt) {
        return false
      }
      if (scope.isReceive !== undefined) {
        return scope.isReceive
      } else {
        return true
      }
    },
    // 取消
    handleClose() {
      this.$confirm('当前填写信息不会保留，是否继续?')
        .then((_) => {
          this.$router.push({ name: 'voucherList' })
        })
        .catch((_) => { })
    },
    onExchange(index, value) {
      let moment = this.tableData[index]
      moment.singleServiceCoupon = value.replace(/[^0-9]/gi, '')
      this.$set(this.tableData, index, moment)
      this.$set(this.allSelectEntData, index + (this.pageNum - 1) * 10, moment)
    },
    // 编辑获取基础信息
    getBasicInfo() {
      return new Promise((resolve) => {
        couponDetail({ id: this.id, grantNum: this.editableTabsValue }).then(
          (res) => {
            if (res.data.code === '0000') {
              this.selectServiceType = []
              this.serviceTypeList = []
              this.baseForm.serviceType = []
              const data = res.data.data
              this.baseForm.couponName = data.couponName
              this.baseForm.couponEndTime = data.couponEndTime
              this.baseForm.couponStartTime = data.couponStartTime
              this.baseForm.totalMoney = data.totalMoney
              this.baseForm.surplusAmount = data.surplusAmount
              this.baseForm.grossAmount = data.grossAmount

              this.ruleForm.consumeRate = data.consumeRate
              this.ruleForm.couponAmount = data.couponAmount
              data.serviceType.map((item) => {
                this.baseForm.serviceType.push({
                  serviceType: item.serviceType,
                  totalMoney: item.totalMoney,
                  grantRate: item.grantRate
                })
                this.serviceTypeList.push({
                  serviceType: item.serviceType,
                  totalMoney: item.totalMoney,
                  grantRate: item.grantRate
                })
                this.selectServiceType.push(item.serviceType)
              })
              this.selectTypeFn(this.selectServiceType)

              this.baseForm.useTime = [data.couponStartTime, data.couponEndTime]
              this.isReceive = data.isEdit
              this.isEditEnt = data.isEditEnt // 白名单是否禁用 先判断isEditEnt  0不能编辑，1可以编辑（这个字段放在上方详情接口）；再判断如果是1，再去判断每条数据的isReceive false（有企业领券，置灰）
              this.firstCouponId = data.firstCouponId

              this.id = data.id

              this.grantNumMax = this.isAddReissue
                ? data.grantNumMax + 1
                : data.grantNumMax // 总共发放n次，如果已经新增 且没有提交数据，则展示为现次数+1，否则就为返回次数

              resolve()
            }
          }
        )
      })
    },
    // 编辑底部企业白名单
    getEditWhiteEnt(params) {
      return new Promise((resolve) => {
        couponDetailByPage({
          id: this.id,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          keyWord: this.key,
          minAmount: this.minAmount,
          maxAmount: this.maxAmount,
          areaName: this.areaName
        }).then((res) => {
          if (res.data.code === '0000') {
            const data = res.data.data
            this.totalRecord = data.totalRecord
            this.tableData = data.results
            // 翻页时，通过获取上次保留的信息，回显
            if (this.allSelectEntData.length) {
              let newTableData = []
              data.results.map((item, index) => {
                this.allSelectEntData.forEach((d, i) => {
                  if (item.entName == d.entName) {
                    item.singleServiceCoupon = d.singleServiceCoupon
                  }
                })
                newTableData.push(item)
              })
              this.tableData = newTableData
            } else {
              this.tableData = data.results
            }
            resolve()
          }
        })
      })
    },
    async getEntWhiteSetting() {
      if (this.id && !this.reissueNewAdd) {
        await this.getBasicInfo()
        this.getEditWhiteEnt()
      } else {
        this.getWhiteEntList()
      }
    },
    // 新建获取白名单企业
    getWhiteEntList() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        keyWord: this.key,
        id: this.firstCouponId,
        minAmount: this.minAmount,
        maxAmount: this.maxAmount,
        areaName: this.areaName
      }
      entWhite(params).then((res) => {
        if (res.data.code === '0000') {
          let data = res.data.data
          this.totalRecord = data.totalRecord
          if (this.allSelectEntData.length) {
            let newTableData = []
            data.results.map((item, index) => {
              this.allSelectEntData.forEach((d, i) => {
                if (item.entName == d.entName) {
                  item.singleServiceCoupon = d.singleServiceCoupon
                } else {
                  item.singleServiceCoupon = item.preCouponAmount
                }
              })
              newTableData.push(item)
            })
            this.tableData = newTableData
          } else {
            data.results.map((item) => {
              item.singleServiceCoupon = item.preCouponAmount
            })
            this.tableData = data.results
          }
        }
      })
    },
    // 发放与使用时间
    changeTime(data) {
      if (data) {
        this.baseForm.couponStartTime = data[0]
        this.baseForm.couponEndTime = data[1]
      } else {
        this.baseForm.couponStartTime = ''
        this.baseForm.couponEndTime = ''
      }
    },
    // 表头全选/单行选中
    handleSelectionChange(val) {
      if (this.id && !this.reissueNewAdd) {
        val.map((item) => {
          if (item.isReceive) {
            this.selectCouponList.push(item)
          }
        })
      } else {
        this.selectCouponList = val
      }
    },
    // 改变列表size
    handleSizeChange(data) {
      this.pageSize = data
      if (this.id && !this.reissueNewAdd) {
        this.getEditWhiteEnt()
      } else {
        this.getWhiteEntList()
      }
    },
    // 改变列表当前页
    handleCurrentChange(data) {
      this.pageNum = data
      if (this.id && !this.reissueNewAdd) {
        this.getEditWhiteEnt()
      } else {
        this.getWhiteEntList()
      }
    },
    // 给选中的企业 批量设置服务券值
    allSetting() {
      this.dialogForm.uniteAmount = ''
      if (this.selectCouponList.length) {
        this.dialogFormVisible = true
      } else {
        this.$message('请先勾选企业')
      }
    },
    // 批量設置
    batchSettings() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          let newTableData = []
          this.tableData.map((item, index) => {
            this.selectCouponList.forEach((d, i) => {
              if (item.entName == d.entName) {
                item.singleServiceCoupon = this.dialogForm.uniteAmount
                this.$set(
                  this.allSelectEntData,
                  index + (this.pageNum - 1) * 10,
                  item
                )
              }
            })
            newTableData.push(item)
          })
          this.tableData = newTableData
          this.dialogFormVisible = false
        }
      })
    },
    // 分发券
    distributeCoupon(status) {
      // if (this.isExceed()) {
      //   return this.$message.error(
      //     '服务券类型发放上限累计金额已超过本次发放总金额，请修改'
      //   )
      // }
      this.entServiceCouponList = []
      this.allSelectEntData.map((item, idex) => {
        if (item) {
          this.entServiceCouponList.push({
            entName: item.entName,
            creditCode: item.creditCode,
            singleServiceCoupon: item.singleServiceCoupon
          })
        }
      })
      let isNeedFill = this.baseForm.serviceType
        .map((item) => {
          if (item.totalMoney != 0 && !item.totalMoney) {
            return item
          }
        })
        .filter((v) => v)
      if (isNeedFill.length) {
        return this.$message.error('请填写服务券金额')
      }
      let params = {
        couponName: this.baseForm.couponName,
        grossAmount: this.baseForm.grossAmount,
        surplusAmount: this.baseForm.surplusAmount,
        couponStartTime: this.baseForm.couponStartTime,
        couponEndTime: this.baseForm.couponEndTime,
        serviceType: this.baseForm.serviceType,

        totalMoney: this.baseForm.totalMoney,
        couponAmount: this.ruleForm.couponAmount,
        consumeRate: this.ruleForm.consumeRate,
        entServiceCouponList: this.entServiceCouponList,
        status: status,
        grantNum: this.editableTabsValue
      }
      if (this.id) {
        Object.assign(params, {
          id: this.reissueNewAdd ? '' : this.id, // 补发新建 id 传空
          firstCouponId: this.firstCouponId
        })
      }
      // 新建时 至少设置一项
      if (!this.id) {
        if (!this.entServiceCouponList.length) {
          this.ruleForm.settingEntItem = ''
        } else {
          this.ruleForm.settingEntItem = 'add'
        }
      }
      this.$refs.baseForm.validate((valid) => {
        if (valid) {
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              distributeCoupon(params).then((res) => {
                if (res.data.code === '0000') {
                  this.$message({
                    type: 'success',
                    message: res.data.data
                  })
                  this.$router.push({ name: 'voucherList' })
                } else {
                  this.$message.error(res.data.msg)
                }
              })
            } else {
              console.log('error submit!!')
              return false
            }
          })
        }
      })
    },
    // 清空服务券金额
    clearServiceAmount() {
      for (const key in this.baseForm.serviceType) {
        this.baseForm.serviceType[key].grantRate = ''
        this.baseForm.serviceType[key].totalMoney = ''
      }
    },
    resetData() {
      this.pageNum = 1
      this.key = ''
      this.minAmount = ''
      this.maxAmount = ''
      this.areaName = ''
      this.getEntWhiteSetting()
    }
  }
}
</script>
<style>
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
}
.hide .el-upload--picture-card {
  display: none;
}
</style>
<style lang="scss" scoped>
/deep/ .el-dialog {
  width: 500px;
  .el-dialog__body {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding: 30px 20px 10px;
  }
}
/deep/ .el-form {
  width: 100%;
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ #tab-add {
  background: #f5f7fa;
}
/deep/ .el-table {
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}
/deep/.el-table thead tr,
/deep/.el-table thead th {
  background: #fafafa;
}
/deep/ .el-table th > .cell {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 550 !important;
}

/deep/.el-checkbox {
  color: rgba(0, 0, 0, 0.85);
}
/deep/ .el-date-editor {
  width: 360px !important;
}
/deep/ .select-box > .el-input {
  width: 300px;
}

.container {
  width: 100%;
  height: 100%;
  .redTips {
    color: red;
  }
  .inputStyle {
    width: 320px;
  }
  .withUnitInput {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    left: 295px;
  }
  /deep/.is-disabled + .withUnitInput {
    color: #c0c4cc;
  }
  .typeTips {
    color: rgba(0, 0, 0, 0.65);
    font-size: 12px;
  }
  .amountRange {
    margin: 0 10px;
    width: 120px;
  }
  .entDataTip {
    display: inline-block;
    margin-top: -15px;
    background: #eff6ff;
    border-radius: 4px;
    padding: 4px 20px;
    font-weight: 500;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
  }
  .tips-icon {
    width: 14px;
    height: 14px;
    color: #0070ff;
    transform: rotate(180deg);
    margin-right: 5px;
    cursor: pointer;
  }
  .editBox {
    display: flex;
    align-items: center;
    > div {
      width: 50%;
      &:first-child {
        text-align: right;
      }
      &:last-child {
        text-align: left;
        margin-left: 20px;
      }
    }
  }
  .tableInputStyle {
    width: 220px;
  }
  .serviceSetBox {
    font-size: 14px;
    color: #606266;
  }
  .unit {
    display: inline-block;
    margin: 0 5px;
  }
  .specialRow {
    margin-bottom: 24px !important;
    /deep/ .el-form-item__content {
      position: relative;
    }
    .totalMoneyTips {
      font-size: 12px;
      color: #606266;
      position: absolute;
      top: 78%;
    }
    /deep/ .el-form-item__error {
      // top: 140%;
    }
  }
  .bottomEntWhite {
    /deep/.el-form-item__label {
      &::before {
        content: '*';
        color: #ff4949;
        margin-right: 4px;
      }
    }
    /deep/ .el-form-item__error {
      left: -21.5%;
    }
  }

  .rateInput {
    width: 100px;
  }
  & > .topContent {
    width: 100%;
    height: calc(100% - 56px);
    overflow-y: auto;
    background: white;
    .topTips {
      margin: 20px 20px 0;
    }
    > .header {
      padding: 24px 24px 0;
      /deep/.el-form-item__label {
        font-weight: 500;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }
      .surplus-box {
        font-weight: 500;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 24px;
        .left-text {
          padding-right: 12px;
        }
      }

      > .title {
        color: rgba(0, 0, 0, 0.85);
        font-size: 16px;
        font-weight: 600;
        > span {
          color: #1890ff;
          font-size: 12px;
          margin-left: 30px;
          display: inline-block;
          border-radius: 2px;
          background-color: rgba(47, 123, 251, 0.05);
        }
      }
      & > .information {
        margin-top: 16px;
        display: flex;
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
        > div {
          width: 400px;
          span {
            color: rgba(0, 0, 0, 0.5);
          }
        }
      }
    }
    > .content {
      margin-top: 16px;
      background: white;
      > .title {
        padding: 16px 21px;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
      }
      > .text {
        padding: 0 21px;
        font-size: 14px;
        line-height: 25px;
        color: rgba(0, 0, 0, 0.5);
        > p {
          color: rgba(0, 0, 0, 0.85);
        }
      }
    }
    .list-box {
      &-header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        &-tag {
          cursor: pointer;

          /deep/ .el-tag--plain.el-tag--info {
            color: rgba(0, 0, 0, 0.85);
            height: 36px;
            line-height: 36px;
          }
        }
      }
    }
    .table-box {
      margin: 20px 0;
      .total-Statistics {
        text-align: right;
        padding: 15px 80px;
        border: 1px solid #eee;
        border-top: none;
        color: rgba(0, 0, 0, 0.85);
        .total-text {
          font-weight: 700;
        }
        .red-tips {
          color: #ff0000;
          padding-right: 20px;
        }
        .highlight {
          color: #1890ff;
          font-size: 25px;
          padding: 6px;
        }
      }
    }
  }
  .dialogBox {
    .tips {
      font-size: 16px;
      margin-bottom: 20px;
    }
  }
  .list-box-header {
    margin-top: 15px;
    .header-left {
      .inputStyle {
        margin-right: 20px;
      }
      .highlight-btn {
        border: 1px solid #0070ff;
        color: #0070ff;
      }
    }
  }

  .table-page {
    width: 100%;
    text-align: right;
    margin-top: 24px;
    margin-bottom: 20px;
  }
  .footer {
    z-index: 9;
    height: 56px;
    &-content {
      position: relative;
      bottom: 7.2%;
      padding: 10px 0;
      background: white;
      width: 100%;
      height: 56px;
      display: flex;
      justify-content: center;
    }
  }
}

.tipDialog {
  .el-icon-info {
    color: #1890ff;
    font-size: 22px;
    vertical-align: middle;
  }
  .title {
    margin-left: 10px;
  }
  .reasonBox {
    margin-bottom: 20px;
  }
}
</style>
